<!-- <div *ngIf="currentUser" style="float: right; margin: 20px;">
    <span>{{ currentUser.userName  }}</span>
    <a [routerLink]="['inspectionbrowser/login']">{{ 'home.logout' | translate  }}</a>
</div> -->
<router-outlet></router-outlet>

<div class="ir-snack-bar-container">
  <snack-bar></snack-bar>
</div>
<load-spinner></load-spinner>
<information #connectionNotification [message]="connectionMessage | translate" [danger]="true"></information>
<modal #versionModal></modal>
<modal #upgradeModal></modal>
